import React, { Component } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

class LandingPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid>
        <Typography className={classes.landingTitle}>CONGRATS!</Typography>
        <Typography className={classes.landingSecond}>
          YOUR PICKS HAVE BEEN SAVED
        </Typography>
        <Button
          className={classes.landingButton}
          onClick={() => this.props.onClick()}
        >
          Go to challenge leaderboard
        </Button>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(LandingPage);
